import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { InputModel } from './input.model';
import { FormControl, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.less']
})
export class InputComponent implements OnInit {

  @Input() inputModel: InputModel = new InputModel();
  @Input() value: any;
  @Output() isInputValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  authInputFormControl: FormControl;

  private addValidators(): void {
    const _validators = new Array<ValidatorFn>();
    this.inputModel.validators.forEach(validator => {
      _validators.push(validator.getValidatorsRule());
    });
    this.authInputFormControl = new FormControl('', _validators);
    this.authInputFormControl.setValue(this.value);
    this.isValid();
  }

  ngOnInit() {
    if (this.inputModel.validators.length !== 0) {
      this.addValidators();
    } else {
      this.authInputFormControl = new FormControl('');
    }

    if (this.inputModel.readOnly) {
      this.authInputFormControl.disable();
    }

    if (this.inputModel.mask) {
      this.inputModel.maskRule = this.inputModel.mask.getMaskRule();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes
        && changes.inputModel
        && changes.inputModel.currentValue
        && changes.inputModel.previousValue) {
      if (changes.inputModel.currentValue.mask !== changes.inputModel.previousValue.mask
        && changes.inputModel.currentValue.mask) {
        this.inputModel.maskRule = changes.inputModel.currentValue.mask.getMaskRule();
      }

      if (changes.inputModel.currentValue.validators !== changes.inputModel.previousValue.validators
        && changes.inputModel.currentValue.validators) {
        if (this.inputModel.validators.length !== 0) {
          this.addValidators();
        } else {
          this.authInputFormControl = new FormControl('');
        }
      }
    }
  }

  sendValue() {
    setTimeout(() => {
      this.authInputFormControl.updateValueAndValidity();
      this.isValid();
      if (this.inputModel.isUpperCase) {
        this.valueChange.next(this.value ? this.value.toUpperCase() : this.value);
      } else {
        this.valueChange.next(this.value);
      }
    });
  }

  isValid() {
    this.isInputValid.next(this.authInputFormControl.valid);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/input.component.ts